export default "__VITE_ASSET__DK5wbHOc__"